var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "print" } }, [
    _c(
      "div",
      { staticClass: "book m-auto" },
      _vm._l(Math.ceil(_vm.stocks.length / _vm.maxItems), function(data, idx) {
        return _c("div", { key: idx, staticClass: "page" }, [
          _c("div", { staticClass: "subpage" }, [
            _c(
              "div",
              { staticClass: "top-header", staticStyle: { border: "none" } },
              [
                idx == 0
                  ? _c("div", { staticClass: "company-info" }, [
                      _vm.shopInfo.logo.thumbnail
                        ? _c("img", {
                            attrs: { src: _vm.shopInfo.logo.thumbnail }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "name" }, [
                        _c("strong", { staticClass: "text-black" }, [
                          _vm._v(_vm._s(_vm.shopInfo.shop_name))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(_vm._s(_vm.shopInfo.info.location.address))
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "document-type" }, [
                  _c("h2", { staticClass: "text-black" }, [
                    _vm._v(_vm._s(_vm.warehouse.name))
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.time))])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "order", staticStyle: { "margin-top": "20px" } },
              [
                _c("table", [
                  _c("thead", [
                    _c("tr", [
                      _vm._m(0, true),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "40%" } }, [
                        _c("b", [_vm._v(_vm._s(_vm.$t("message.item")))])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("apps.inventory.message.warningstock")
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.$t("apps.inventory.message.binlocation"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.$t("apps.inventory.message.balance"))
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.groupItems[idx].items, function(item, idx_) {
                      return _c("tr", { key: idx_ }, [
                        _c("td", { attrs: { width: "10px" } }, [
                          _vm._v(_vm._s(_vm.maxItems * idx + (idx_ + 1)))
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { width: "40%" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.getProductFullName(
                                item.product.product_name,
                                item.sku.attributes
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _vm._v(
                            _vm._s(_vm.getNumber(item.stock.control.minstock))
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.getBinLocationNamesByStock(item).join(", ")
                              ) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _vm._v(_vm._s(_vm.getNumber(item.stock.instock)))
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ]
            )
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { width: "10px" } }, [_c("b", [_vm._v("#")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ea3305ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea3305ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/stockcontrol/include/PrintPreview.vue
// module id = null
// module chunks = 